import React from 'react';
import { Box } from '@material-ui/core';
import clsx from 'clsx';
import LocationCityIcon from '@material-ui/icons/LocationCity';
import { makeStyles } from '@material-ui/core/styles';
import MyLocationIcon from '@material-ui/icons/MyLocation';

const useStyles = makeStyles((theme) => ({
  box: {
    padding: '20px 15px',
    display: 'flex',
    height: 175,
    justifySelf: 'stretch',
    flexDirection: 'column',
  },
  boxContent: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 20,
  },
  boxText: {
    fontSize: '1rem',
  },
  boxDescription: {
    paddingBottom: 8,
  },
  linearChartContainer: {
    position: 'relative',
    width: '100%',
    marginLeft: 24,
    alignSelf: 'center',
    [theme.breakpoints.down('xs')]: {
      alignSelf: 'flex-end',
    },
  },
  linearChartBar: {
    position: 'relative',
    backgroundColor: theme.palette.primary.main,
    height: 30,
    borderRadius: 5,
    marginBottom: '.7rem',
  },
  linearChartBarLabel: {
    fontSize: '1rem',
    whiteSpace: 'nowrap',
    marginBottom: 8,
  },
  linearChartBarValue: {
    position: 'absolute',
    top: '50%',
    right: 5,
    transform:'translate(0, -50%)',
    fontSize: '1.5rem',
    color: 'white',
  },
  linearChartScale: {
    position:'relative',
    width: '100%',
    height: 5,
    borderLeft: `1px solid ${theme.palette.text.primary}`,
    borderRight: `1px solid ${theme.palette.text.primary}`,
    marginBottom: '.7rem',
  },
  linearChartScaleLine: {
    position: 'absolute',
    top: '50%',
    left: 0,
    width: '100%',
    height: 1,
    backgroundColor: theme.palette.text.primary,
  },
  linearChartScaleValue: {
    position: 'absolute',
    top: '100%',
    fontSize: '.7rem',
    lineHeight: '100%',
  },
  linearChartScaleValueMin: {
    left: 5,
  },
  linearChartScaleValueMax: {
    right: 5,
  },
}));

const LinearChart = ({ districtProjectNumber, cityProjectNumber, label, gridArea }) => {
  const classes = useStyles();
  const intDistrictProjectNumber = parseInt(districtProjectNumber, 10);
  const intCityProjectNumber = parseInt(cityProjectNumber, 10);
  const maxScaleValue = intDistrictProjectNumber > intCityProjectNumber
    ? Math.ceil(intDistrictProjectNumber + intDistrictProjectNumber * 0.1)
    : Math.ceil(intCityProjectNumber + intCityProjectNumber * 0.1);
  const value1Width = intDistrictProjectNumber / maxScaleValue * 100;
  const value2Width = intCityProjectNumber / maxScaleValue * 100;
  return (
    <Box
      className={classes.box}
      style={{ gridArea: gridArea }}
      boxShadow={3}
    >
      <p className={classes.boxText}>{label}</p>
      <div className={classes.boxContent}>
        <div>
          <p className={classes.linearChartBarLabel}>Dzielnicowe <MyLocationIcon/></p>
          <p className={classes.linearChartBarLabel}>Ogólnomiejskie <LocationCityIcon/></p>
        </div>
        <div className={classes.linearChartContainer}>
          <div className={classes.linearChartBar} style={{ width: `${value1Width}%` }}>
            <span className={classes.linearChartBarValue}>{districtProjectNumber === 0 ? null : districtProjectNumber}</span>
          </div>
          <div className={classes.linearChartBar} style={{ width: `${value2Width}%` }}>
            <span className={classes.linearChartBarValue}>{cityProjectNumber === 0 ? null : cityProjectNumber}</span>
          </div>
          <div className={classes.linearChartScale}>
            <div className={classes.linearChartScaleLine} />
            <span className={clsx(classes.linearChartScaleValue, classes.linearChartScaleValueMin)}>0</span>
            <span className={clsx(classes.linearChartScaleValue, classes.linearChartScaleValueMax)}>{maxScaleValue}</span>
          </div>
        </div>
      </div>
    </Box>
  )
};

export default LinearChart;
